
import { View }             from 'backbone';

import BaseControlView      from 'BaseControlView.js';
import template             from 'report/control-line-chart.ejs';
import eventBus             from 'EventBus.js';
import constants            from "Constants.js";
import dragAndDropService   from 'DragDropService.js';
import resizeController     from 'ResizeController.js';
import * as d3              from 'd3.js';
import c3                   from 'c3.js';
import util                 from "util/Util";


class LineChartView extends BaseControlView  {

        initialize( opts ) {
            super.initialize( opts );
            this.template = template;
            this.tagName = 'div';
            this.listenTo( eventBus, 'ButtonThemeChange', this.themeChangeRender);
                    
            this.listenTo(this.model, 'change', this.render);

            return this;
        }

        chartConfiguration(){
           	var dataType = {
                segment: 'line',
                curve: 'spline',
                horizontal: 'step',
                vertical: 'step',
                step: 'step',
                reverseStep: 'step'
            },
            
            myModel = this.model,

            c3config = {
                bindto: constants.ID_SEL + this.model.get('id')+' div.line-chart',
                legend: { show: false },
                size: { height: util.extractNum(this.model.get('height')) -2, width: util.extractNum(this.model.get('width'))-2 }, // adjust for selectable border.

               data: {
                    type: dataType[myModel.get('lineChartType')],
                    colors: {data1:myModel.get('lineColor')},
                    columns: [
                        ['data1', 10, -5, 50, 20]
                    ]
                }     
            }

            return c3config;

        }    
       
        get kind() {
            return 'ButtonControlView';
        }

        render() {

            super.render();

            d3.select("div.line-chart").style("background-color", "transparent");
            c3.generate( this.chartConfiguration() );

            return this;
        }
}

export default LineChartView;
